import React from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const ErrorFallback = ({ error, onRetry, title = "Something went wrong" }) => {
  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-8 text-center">
      <div className="flex flex-col items-center space-y-4">
        <div className="w-16 h-16 bg-error/10 rounded-full flex items-center justify-center">
          <Icon name="AlertCircle" size={32} className="text-error" strokeWidth={2} />
        </div>
        
        <div className="space-y-2">
          <h3 className="font-heading text-xl font-semibold text-foreground">
            {title}
          </h3>
          {error && (
            <p className="font-body text-sm text-muted-foreground">
              {error?.message || 'An unexpected error occurred'}
            </p>
          )}
        </div>

        {onRetry && (
          <Button
            variant="default"
            onClick={onRetry}
            iconName="RefreshCw"
            className="mt-4"
          >
            Try Again
          </Button>
        )}
      </div>
    </div>
  );
};

export default ErrorFallback;